import crownImg from '@/assets/icons/crown.svg';
// import maxImg from '@/assets/images/richoldman.png';
import maxImg from '@/assets/icons/max-utility.svg';
import badgeKothImg from '@/assets/images/peak_evolution.svg';
import {
  ALL_CONFIGS,
  BLACK_LIST_ADDRESS,
  isEvmNetwork,
  MAX_INTEGER,
  MAX_UTIL_URL,
  TOTAL_SUPPLY_TOKEN,
  TRADING_DEFI_URL,
} from '@/config';
import UserContext from '@/context/UserContext';
import { Web3TradingService } from '@/factory/Web3TradingService';
import { formatNumberKMB } from '@/utils/format';
import {
  ENDPOINTS,
  calcBondingCurveOfIDO,
  calcIdoCoinPrice,
  calculateMarketCap,
  calculateTokenPrice,
  getKoth,
  reduceString,
  toBN,
  toPublicKey,
} from '@/utils/util';
import { CoinType } from '@/zustand-store/coin/useCoinStore';
import BigNumber from 'bignumber.js';
import { useContext, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { Link } from 'wouter';

const Banner = () => {
  const { solPrice, oraiPrice } = useContext(UserContext);
  const [kothCoin, setKothCoin] = useState(null);
  const [curveInfo, setCurveInfo] = useState(null);
  // const curveLimit = useGetConfigState('agentCurveLimit');
  // const initBondingCurve = useGetConfigState('agentCurveInit');
  const curveLimit =
    curveInfo?.curveLimit || kothCoin?.bondingCurveLimit || MAX_INTEGER;
  const initBondingCurve = kothCoin?.bondingCurveInit || 0;
  const nativePrice = isEvmNetwork ? oraiPrice : solPrice;

  useEffect(() => {
    const fetchData = async () => {
      const kingCoin = await getKoth(ENDPOINTS.BACKEND);
      if (kingCoin) {
        setKothCoin(kingCoin);

        const coinType = kingCoin.metadata?.tags;
        const web3 = Web3TradingService.getInstance(coinType);
        const curveAccount = await web3.getBondingCurveOfToken(kingCoin.token);

        if (curveAccount) {
          setCurveInfo(curveAccount);
        }
      }
    };
    fetchData();
  }, []);

  const bondingCurveValue = toBN(
    (kothCoin?.ethReserve || kothCoin?.lamportReserves || 0).toString(),
  )
    .minus(initBondingCurve)
    .toNumber();

  const bondingCurvePercentNormal = toBN(bondingCurveValue)
    .multipliedBy(100)
    .div(curveLimit);

  const isIdoToken = kothCoin?.metadata?.isIdoLaunch;
  const bondingCurvePercentOrg = isIdoToken
    ? calcBondingCurveOfIDO(
        kothCoin.tokenReserves,
        curveInfo?.initToken,
        curveInfo?.partyAmount,
      ) // TODO: set token init amount is default
    : bondingCurvePercentNormal;

  const bondingCurvePercent = toBN(
    bondingCurvePercentOrg,
  ).isGreaterThanOrEqualTo(100)
    ? 100
    : toBN(bondingCurvePercentOrg).isLessThanOrEqualTo(0)
    ? 0
    : toBN(bondingCurvePercentOrg).toFixed(2, 1);

  const enableTokenAfterGolive =
    kothCoin?.date &&
    new Date(kothCoin.date).getTime() >
      ALL_CONFIGS.OFFICIAL_TIME - ALL_CONFIGS.TIMER.DAY_TO_SECONDS;

  const isListedOnRay = !!kothCoin?.raydiumPoolAddr;

  const idoPrice = calcIdoCoinPrice(kothCoin, curveInfo);
  const newPrice = isIdoToken
    ? idoPrice * nativePrice
    : calculateTokenPrice(
        curveInfo?.['reserveToken'],
        curveInfo?.['reserveLamport'],
        kothCoin?.decimals,
        nativePrice,
      );

  const marketCap = calculateMarketCap(
    curveInfo?.['reserveToken'],
    kothCoin?.decimals,
    newPrice,
  );

  const isScamReported = kothCoin?.isScamReported;

  return (
    <>
      <div className="w-full h-[263px] md:h-[450px] relative bg-banner flex items-center justify-center">
        <div className="h-full flex justify-center md:justify-between items-end md:items-center w-full max-w-[1216px]">
          <div className="hidden md:flex flex-col items-start">
            <div className="text-[56px] text-[#E8E9EE] leading-[64px] uppercase font-medium">
              Take your agent
              <br />
              to the promised land
            </div>
            <div className="mt-6 mb-14 text-base font-medium text-[#E8E9EE]">
              $MAX is the utility token of the launchpad
            </div>
            <div className="flex gap-2">
              <div className="flex items-center uppercase p-1 rounded border-[2px] border-solid border-[rgba(255,255,255,0.25)] cursor-pointer hover:border-[rgba(255,255,255)] transition-all ease-in duration-150">
                <Link
                  href="/create-coin"
                  className="rounded h-10 bg-white px-6 py-2 text-[#080A14]"
                >
                  Launch your AGENT
                </Link>
              </div>

              <div className="uppercase p-1 rounded border-[2px] border-solid border-[rgba(255,255,255,0.25)] cursor-pointer hover:border-[rgba(255,255,255)] transition-all ease-in duration-150">
                <Link href={MAX_UTIL_URL}>
                  <div className="rounded h-10 bg-[rgba(252,252,252,0.24)] backdrop-blur-[48px] px-6 py-2 text-[#FCFCFC] flex items-center">
                    <img
                      src={maxImg}
                      alt="maxImg"
                      width={20}
                      height={20}
                      className="rounded-full mr-2"
                    />
                    MAX Utility
                  </div>
                </Link>
              </div>
            </div>
          </div>
          {kothCoin &&
            enableTokenAfterGolive &&
            !BLACK_LIST_ADDRESS.includes(kothCoin.token) &&
            !isScamReported && (
              // <div className="bg-[linear-gradient(180deg,_#E4775D_0%,_#292D46_100%)] rounded-xl p-0.5">
              <Link
                className="translate-y-1/2 md:translate-y-0 relative bg-[#E4775D] rounded-xl p-0.5 min-w-[310px] cursor-pointer md:mx-0 mx-2"
                href={
                  kothCoin?.metadata?.tags === CoinType.DEFAI
                    ? `${TRADING_DEFI_URL}/${kothCoin.token}`
                    : `/trading/${kothCoin.token}`
                }
              >
                <img
                  src={badgeKothImg}
                  alt="badgeKothImg"
                  className="absolute bottom-0 left-[6px] translate-y-1/2"
                />
                <img
                  src={crownImg}
                  alt="crownImg"
                  className="absolute top-0 right-[6px] -translate-y-1/2 translate-x-1/2"
                />
                <div className="bg-[linear-gradient(180deg,_#080A14_0%,_#292D46_100%)] rounded-xl flex items-center gap-3 md:px-6 md:py-4 py-4 px-2">
                  <div className="w-full max-w-[78px] h-[78px]">
                    <img
                      src={kothCoin.url}
                      alt="richolman"
                      className="border-[3px] solid rounded-full border-[#E8E9EE] w-[78px] h-[78px]"
                    />
                  </div>
                  <div className="flex flex-col text-[#E8E9EE]">
                    <div className="text-[#84869A] uppercase text-[12px]">
                      created by&nbsp;
                      <Link
                        href={`/profile/${kothCoin.creator?.wallet}`}
                        className="text-[#E4775D] underline normal-case"
                      >
                        {reduceString(kothCoin.creator?.wallet || '', 4, 4)}
                      </Link>
                    </div>
                    <div className="text-[16px] font-medium leading-6 mt-2">
                      {/* Vanga the prophet (${kothCoin.ticker}) */}
                      {kothCoin.name} (${kothCoin.ticker})
                    </div>
                    <div className="text-[#9192A0] text-[12px] uppercase mt-4 ">
                      Marketcap&nbsp;&nbsp;
                      <span className="text-[#E8E9EE]">
                        {isIdoToken
                          ? formatNumberKMB(
                              newPrice * TOTAL_SUPPLY_TOKEN * nativePrice,
                            )
                          : formatNumberKMB(
                              Number(marketCap || kothCoin.marketcap || 0),
                            )}
                        ({isListedOnRay ? 100 : bondingCurvePercent}%)
                      </span>
                    </div>
                    <div className="w-full max-w-[235px] mt-2 px-[2px] py-[1px] rounded-[28px] bg-[#1A1C28] border border-solid border-[#30344A]">
                      <div
                        className="rounded-[999px] h-2 bg-barrie"
                        style={{
                          width: `${
                            isListedOnRay ? 100 : bondingCurvePercent
                          }%`,
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </Link>
            )}
        </div>
      </div>
      <div
        className={twMerge(
          'md:hidden mt-6 flex flex-col items-start px-4',
          kothCoin && 'mt-[96px]',
        )}
      >
        <div className="text-[30px] text-[#E8E9EE] leading-[48px] uppercase font-medium">
          Take your agent
          <br />
          to the promised land
        </div>
        <div className="mt-6 mb-5 text-base font-medium text-[#E8E9EE]">
          $MAX is the utility token of the launchpad
        </div>
        <div className="uppercase p-1 py-1 rounded border-[2px] border-solid border-[rgba(255,255,255,0.25)] cursor-pointer hover:border-[rgba(255,255,255)] transition-all ease-in duration-150">
          <Link
            href="/create-coin"
            className="rounded h-7 flex bg-white px-6 py-1 text-[#080A14]"
          >
            Launch your AGENT
          </Link>
        </div>
        <div className="mt-2 uppercase p-1 py-1 rounded border-[2px] border-solid border-[rgba(255,255,255,0.25)] cursor-pointer hover:border-[rgba(255,255,255)] transition-all ease-in duration-150">
          <Link href={MAX_UTIL_URL}>
            <div className="rounded h-7 flex items-center w-full bg-[rgba(252,252,252,0.24)] backdrop-blur-[48px] px-6 py-1 text-[#FCFCFC]">
              <img
                src={maxImg}
                alt="maxImg"
                width={18}
                height={18}
                className="rounded-full mr-2"
              />
              MAX Utility
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Banner;
